export const REGION_ORDER = ["MB", "MN", "MT"];

export const REGION_META = {
  MB: { code: "MB", label: "Miền Bắc", short: "MB", hasPrize8: false },
  MN: { code: "MN", label: "Miền Nam", short: "MN", hasPrize8: true },
  MT: { code: "MT", label: "Miền Trung", short: "MT", hasPrize8: true },
};

export const REGION_SELECT_OPTIONS = [
  { value: "MN", label: "Miền Nam" },
  { value: "MB", label: "Miền Bắc" },
  { value: "MT", label: "Miền Trung" },
];

const LOTTERY_TYPE_ALIASES = {
  all: "all",
  "*": "all",
  xsmb: "MB",
  mb: "MB",
  "mien-bac": "MB",
  xsmt: "MT",
  xmst: "MT",
  xstm: "MT",
  mt: "MT",
  "mien-trung": "MT",
  xsmn: "MN",
  mn: "MN",
  "mien-nam": "MN",
};

export const LOTTERY_TYPE_TITLES = {
  all: "Kết quả xổ số 3 miền hôm nay",
  MB: "Kết quả xổ số miền Bắc hôm nay",
  MN: "Kết quả xổ số miền Nam hôm nay",
  MT: "Kết quả xổ số miền Trung hôm nay",
};

export function resolveLotteryRegions(lotteryType) {
  const key = String(lotteryType || "all").trim().toLowerCase();
  const resolved = LOTTERY_TYPE_ALIASES[key] ?? "all";
  if (resolved === "all") return REGION_ORDER;
  return [resolved];
}

export const PRIZE_ROWS = [
  { key: "prize8", label: "Giải tám", shortLabel: "G8", size: "xl", regions: ["MN", "MT"] },
  { key: "prize7", label: "Giải bảy", shortLabel: "G7", size: "lg" },
  { key: "prize6", label: "Giải sáu", shortLabel: "G6", size: "lg" },
  { key: "prize5", label: "Giải năm", shortLabel: "G5", size: "md" },
  { key: "prize4", label: "Giải tư", shortLabel: "G4", size: "md" },
  { key: "prize3", label: "Giải ba", shortLabel: "G3", size: "md" },
  { key: "prize2", label: "Giải nhì", shortLabel: "G2", size: "md" },
  { key: "prize1", label: "Giải nhất", shortLabel: "G1", size: "md" },
  { key: "specialPrize", label: "Giải Đặc Biệt", shortLabel: "ĐB", size: "special" },
];

export const PRIZE_SLOT_COUNTS = {
  MB: {
    prize7: 4,
    prize6: 3,
    prize5: 6,
    prize4: 4,
    prize3: 6,
    prize2: 2,
    prize1: 1,
    specialPrize: 1,
  },
  MN: {
    prize8: 1,
    prize7: 1,
    prize6: 3,
    prize5: 1,
    prize4: 7,
    prize3: 2,
    prize2: 1,
    prize1: 1,
    specialPrize: 1,
  },
  MT: {
    prize8: 1,
    prize7: 1,
    prize6: 3,
    prize5: 1,
    prize4: 7,
    prize3: 2,
    prize2: 1,
    prize1: 1,
    specialPrize: 1,
  },
};

export const WEEKDAYS_VN = ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"];
export const CALENDAR_DOW = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];

export const MONTHS_VN = [
  "Tháng 1",
  "Tháng 2",
  "Tháng 3",
  "Tháng 4",
  "Tháng 5",
  "Tháng 6",
  "Tháng 7",
  "Tháng 8",
  "Tháng 9",
  "Tháng 10",
  "Tháng 11",
  "Tháng 12",
];
